<template>
  <RevLink
    v-bind="$attrs"
    class="body-2 text-nowrap transition-all duration-700 ease-in-out hover:body-2-bold hover:no-underline"
    :class="{
      'body-2-bold': active && !menuActive,
      'text-action-default-low': menuActive,
    }"
    :style="{ color: color }"
    :underlined="false"
  >
    <div
      class="relative flex h-full items-center text-nowrap after:bg-action-default-hi after:pointer-events-none after:absolute after:-bottom-[1px] after:left-0 after:h-[2px] after:w-full after:opacity-0 after:content-[''] hover:after:opacity-100"
      :class="[active && !menuActive ? 'after:opacity-100' : '']"
    >
      <component :is="icon" v-if="icon" />
      <BoldHack :text="label" />
    </div>
  </RevLink>
</template>

<script setup lang="ts">
import type { Component } from 'vue'

import { RevLink } from '@ds/components/Link'

import BoldHack from './BoldHack.vue'

defineOptions({ inheritAttrs: false })

defineProps<{
  label: string
  icon?: Component
  active?: boolean
  menuActive?: boolean
  color?: string
}>()
</script>
